import classNames from 'classnames';
import POPUP from '../../../../constants/popup';
import React, { useEffect } from 'react';
import { ReactComponent as IconDraw } from '../../../images/icons/ico-draw-gray.svg';
import { ReactComponent as IconSettings } from '../../../images/icons/ico-settings.svg';
import { ReactComponent as IconSurrender } from '../../../images/icons/ico-surrender.svg';
import { ReactComponent as IconGame } from '../../../images/icons/ico-new-game.svg';
import {ReactComponent as IconArena} from '../../../images/arena-big-logo.svg';
import "./gameControls.scss"
import { setTournamentTimer } from "../utils/tournamentTimer";

const GameControls = ({
  rules,
  openPopup,
  newGame,
  onNewArenaGame,
  canProposeDraw,
  canSurrender,
  isUserAnonymous,
  isGameFinished,
  isGameActive,
  tournament,
}) => {

  useEffect(() => {
    if (Object.keys(tournament).length !== 0) {
      setTournamentTimer(tournament.start, tournament.finish)
    }
  }, [tournament]);

  return (
    <div className="side-area">
      <div className="side-area-content">

        <div className="side-area-top">
          <button
            className={classNames('icon ', 'flag-' + rules.icon)}
            onClick={() => openPopup(POPUP.RULES, { rules })}
          >
            Game rules
          </button>
          <button
            onClick={() => openPopup(POPUP.SETTINGS)}
          >
            <span className="icon-flex">
              <IconSettings />
            </span>
            Settings
          </button>
        </div>

        {Object.keys(tournament).length !== 0 && (
          <div className="side-area-center">
            <IconArena/>
            <div className="timer">
              <div className="timer-text">ends in: </div>
              <div className="tournament-timer"/>
            </div>
          </div>
        )}

        <div className="side-area-bottom">
          {!isGameFinished && !isUserAnonymous && isGameActive && (
            <>
              <button
                onClick={() => openPopup(POPUP.DRAW_PROPOSAL_CONFIRM)}
                disabled={canProposeDraw}
              >
                <span className="icon-flex">
                  <IconDraw />
                </span>
                Propose draw
              </button>
              <button
                onClick={() => openPopup(POPUP.SURRENDER_CONFIRM)}
                disabled={canSurrender}
              >
                <span className="icon-flex">
                  <IconSurrender />
                </span>
              Resign
              </button>
            </>
          )}
          {isGameFinished && (
            <button className="side-area-game" onClick={Object.keys(tournament).length === 0 ? newGame : onNewArenaGame}>
              <span className="icon-flex">
                <IconGame />
              </span>
            New game
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GameControls;
